import React, { useEffect, useMemo, useState } from 'react';
import styles from './styles.module.scss';
import { motion } from 'framer-motion';

interface Props {
    src: string;
    iconSrc: string;
    onHoverStart?: () => void;
    onHoverEnd?: () => void;
    isFirst?: boolean;
}

const duration = 0.4;
const delay = 0.6;

const iconVariants = {
    start: {
        opacity: 0,
    },
    active: {
        opacity: 1,
        transition: {
            delay: duration + delay + 0.2,
        },
    },
};

const AnimatedLayer = (props: Props) => {
    const [stage, setStage] = useState<'start' | 'active'>('start');

    const variants = useMemo(
        () => ({
            start: {
                marginLeft: props.isFirst ? '0px' : '-208px',
                transition: {
                    duration,
                },
            },
            active: {
                marginLeft: props.isFirst ? '0px' : '-32px',
                transition: {
                    duration,
                    delay,
                },
            },
        }),
        [props.isFirst]
    );

    useEffect(() => {
        setStage('active');
    }, []);

    return (
        <motion.div
            className={styles.container}
            variants={variants}
            initial="start"
            animate={stage}
            whileHover={stage === 'active' ? { y: '-60px', transition: { duration: 0.2 } } : {}}
            onHoverStart={props.onHoverStart}
            onHoverEnd={props.onHoverEnd}
        >
            <img src={props.src} />
            <motion.img src={props.iconSrc} className={styles.icon} variants={iconVariants} initial="start" animate={stage} />
        </motion.div>
    );
};

AnimatedLayer.defaultProps = {
    isFirst: false,
    // eslint-disable-next-line react/default-props-match-prop-types
    onHoverStart: () => {
        // nothing
    },
    // eslint-disable-next-line react/default-props-match-prop-types
    onHoverEnd: () => {
        // nothing
    },
};

export default AnimatedLayer;
